import React from 'react'
import { withStyles, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import Header from './Header';

const style = theme => ({
	root: {
	},
})

function SearchHeader({
	classes,
	title,
	placeholder,
	onChange,
	value
}) {

	return (
		<Header
			className={classes.root}
			title={title}
		>
			<TextField
				fullWidth
				id='list-search'
				placeholder={placeholder}
				onChange={onChange}
				value={value}
			/>
		</Header>

	)
}

SearchHeader.propTypes = {
	classes: PropTypes.any,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.func,
	]),
	placeholder: PropTypes.string,
	onChange: PropTypes.func,
	value: PropTypes.string,
}

SearchHeader.defaultProps = {
}

export default withStyles(style)(SearchHeader);